<template>
    <div class="filter-chip-group">
        <div v-if="label" class="filter-chip-group__label mb-2 d-flex align-center">
            <v-icon v-if="icon" size="17" color="muted" class="me-1">{{ icon }}</v-icon>
            <span class="details-text muted--text font-weight-medium">{{ label }}</span>
        </div>
        <div class="filter-chip-group__scroll">
            <v-chip
                :color="isActive(null) ? 'primary' : ''"
                :dark="isActive(null)"
                small
                label
                class="filter-chip-group__chip"
                :class="{'filter-chip-group__chip--active': isActive(null)}"
                @click="select(null)"
            >
                {{ allLabel }}
            </v-chip>
            <v-chip
                v-for="item in items"
                :key="item.value"
                :color="isActive(item.value) ? 'primary' : ''"
                :dark="isActive(item.value)"
                small
                label
                class="filter-chip-group__chip"
                :class="{'filter-chip-group__chip--active': isActive(item.value)}"
                @click="select(item.value)"
            >
                <v-icon v-if="item.icon" left size="15">{{ item.icon }}</v-icon>
                {{ item.text }}
            </v-chip>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: null,
        },
        items: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
        allLabel: {
            type: String,
            default: 'الكل',
        },
    },
    methods: {
        isActive(value) {
            const normalized = value === null || value === '' ? null : String(value);
            const current = this.value === null || this.value === '' ? null : String(this.value);
            return normalized === current;
        },
        select(value) {
            const next = value === null || value === '' ? null : value;
            if (next !== this.value) {
                this.$emit('input', next);
                this.$emit('change', next);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.filter-chip-group__scroll {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    overflow-x: auto;
    padding-bottom: 2px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

@media (min-width: 960px) {
    .filter-chip-group__scroll {
        flex-wrap: wrap;
        overflow-x: visible;
    }
}

.filter-chip-group__chip {
    flex-shrink: 0;
    font-weight: 600;
    height: 32px !important;
    border-radius: 8px !important;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    background: #f0f2f5 !important;
    color: #4e515f !important;

    &:hover {
        transform: translateY(-1px);
    }
}

.filter-chip-group__chip--active {
    background: var(--v-primary-base) !important;
    color: #fff !important;
}

.theme--dark .filter-chip-group__chip:not(.filter-chip-group__chip--active) {
    background: rgba(255, 255, 255, 0.08) !important;
    color: #e0e0e0 !important;
}
</style>
